import styles from "./HotspotModal.module.css";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import ToggleButton from 'react-bootstrap/ToggleButton';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Input from "./../common/input/Input";
import { useAppStore } from "../../hooks/store/useAppStore";
import {
  showHotspotModalSelector,
  currentHotspotSelector,
  hotspotActiveIndexSelector,
} from "../../hooks/store/getters";
import {
  setShowHotspotModalSelector,
  setTourSceneHotspotSelector,
  removeHotspotFromSceneSelector,
} from "../../hooks/store/setters";
import HotspotVideo from './hotspot-video/HotspotVideo';
import HotspotAudio from './hotspot-audio/HotspotAudio';
import HotspotImage from './hotspot-image/HotspotImage';
import HotspotSene from "./hotsport-scene/Hotpsot-scene";
import { HOTSPOT_TYPES } from "../../hooks/store/Types";
import { setConfirmModelSelector } from "../../hooks/store/setters";
import { currentHotspotErrorSelector } from "../../hooks/store/getters";
import { useValidateForm } from "../../hooks/UseValidateForm";
import { setChangeHotspotPositionSelector } from "../../hooks/store/setters";

const HotspotModal = () => {
  const showHotspotModal = useAppStore(showHotspotModalSelector);
  const setShowHotspotModal = useAppStore(setShowHotspotModalSelector);
  const setSceneHotspot = useAppStore(setTourSceneHotspotSelector);
  const currentHotspot = useAppStore(currentHotspotSelector);
  const removeHotspotFromScene = useAppStore(removeHotspotFromSceneSelector);
  const hotspotActiveIndex = useAppStore(hotspotActiveIndexSelector);
  const setConfirmModel = useAppStore(setConfirmModelSelector);
  const currentHotspotError = useAppStore(currentHotspotErrorSelector);
  const valiateTour = useValidateForm();
  const setChangeHotspotPosition = useAppStore(setChangeHotspotPositionSelector);

  
  
  console.log('in hotsppt model');
  const hotspotInfoInputChangeHandler = ({ target: { name, value } }) => {
    const { hotspotType } = currentHotspot;
    setSceneHotspot({ [name]: value });
    valiateTour.validateHotspot({ key:name,value,hotspotType }); 
  };

  const validateForm = () => {
    let hotspotValid = true;
    const hotspotKeys = Object.keys(currentHotspot);
    hotspotKeys.forEach((key, index) => {
       hotspotValid = valiateTour.validateHotspot({ key, value:currentHotspot[key], hotspotType})
    })

    if(hotspotValid) {
      setShowHotspotModal(false);
    }

  }

  const deleteHotpspotConfirmModel = () => {
    setConfirmModel(
      { show: true, 
        title: "Delete Hotspot",
        text: "are you sure want to delete",
        cancelButtonText: "Cancel",
        successButtonText: "Delete",
        successCallback: handleDeleteHotpsot,
      }
    );
  }

  const handleDeleteHotpsot = () => {
    setShowHotspotModal(false);
    setConfirmModel({ show: false });
    removeHotspotFromScene(hotspotActiveIndex);
  };

  const changeHotspot = () => {
    setChangeHotspotPosition(true);
    setShowHotspotModal(false);
  }

  const updateHotspotType = type => setSceneHotspot({ hotspotType: type })
  
  if (!currentHotspot) return null;
  
  const { name, description, hotspotType } = currentHotspot;
  

  return (
    <Modal
      show={showHotspotModal}
      onHide={() => validateForm()}
      centered
      size="xl"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <span>Hotspot Details</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={styles.hotspotDetails}>
          
          <div className={styles.hotspotTypesSelector}>
            <div>
              <label className={styles.hotspotTypesSelectorLabel}>Hotspot Type: </label>
              <ButtonGroup toggle >
                <ToggleButton
                  type="radio"
                  variant="outline-dark"
                  name="hotspotType"
                  value={HOTSPOT_TYPES.MOVE}
                  checked={hotspotType === HOTSPOT_TYPES.MOVE}
                  onChange={(e) => updateHotspotType(HOTSPOT_TYPES.MOVE)}
                >
                  Scene Hotspot
                </ToggleButton>
                <ToggleButton
                  type="radio"
                  variant="outline-dark"
                  name="hotspotType"
                  value={HOTSPOT_TYPES.DATA}
                  checked={hotspotType === HOTSPOT_TYPES.DATA}
                  onChange={(e) => updateHotspotType(HOTSPOT_TYPES.DATA)}
                >
                  Details Hotspot
                </ToggleButton>
                
              </ButtonGroup>
            </div>
            <div>  
              <Button
                variant="outline-dark"
                block
                onClick={changeHotspot}
                className
              >
                Change Position
              </Button>
            </div>        
          </div>


          { hotspotType===HOTSPOT_TYPES.DATA && 
            <Row>
              <Col md={6}>
                <HotspotImage />
              </Col>
              
              <Col md={6}>
                <div className={styles.hotspotDetailsForm}>
                  <Input
                    label="Name"
                    onChange={(e) => hotspotInfoInputChangeHandler(e)}
                    value={name}
                    name="name"
                    error={currentHotspotError?.name}
                  />
                  <Input
                    label="Description"
                    type="textarea"
                    name="description"
                    onChange={(e) => hotspotInfoInputChangeHandler(e)}
                    value={description}
                    error={currentHotspotError?.description}
                  />

                  <HotspotAudio />
                  
                  <HotspotVideo />

                  <div className={styles.hotspotFormFooter}>
                    {/* <Button variant="dark" block className={styles.submitBtn}>Submit</Button> */}
                    <Button
                      variant="info"
                      block
                      onClick={validateForm}
                    >
                      Save
                    </Button>
                    <Button
                      variant="outline-danger"
                      block
                      onClick={deleteHotpspotConfirmModel}
                    >
                      Delete
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
          }
          { hotspotType===HOTSPOT_TYPES.MOVE &&  
          
            <Row className="justify-content-center">
            
              <HotspotSene 
                hotspot={currentHotspot}
                onChange={hotspotInfoInputChangeHandler} 
                errorSceneIndex={currentHotspotError?.sceneIndex}
                errorName ={currentHotspotError?.name}
              />
              <Col md={4} sm={12}>
                <div className={styles.hotspotFormFooter}>
                <Button
                      variant="info"
                      block
                      onClick={validateForm}
                    >
                      Save
                    </Button>
                  <Button
                    variant="outline-danger"
                    block
                    onClick={deleteHotpspotConfirmModel}
                  >
                    Delete
                  </Button>
                </div>
              </Col>
            </Row>
          }
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default HotspotModal;
